import { Link } from "react-router-dom";

export const ProjectHomePage = () => {
  return (
    <div className="absolute h-full w-full bg-slate-900 text-white flex flex-col">
      <nav className="w-full">
        <div className="sm:pl-10 pl-4 pr-2 pt-6 sm:pt-8 pb-4 flex justify-between items-center">
          <div className="flex">
            <Link
              to="/workspaces/VzSj79"
              className="text-xl font-semibold mr-4"
            >
              <img
                src="/logo.svg"
                alt="TwinVerse Logo"
                className="h-6 w-auto inline-block mr-2"
              />
              TwinVerse
            </Link>
          </div>
          <Link to="/workspaces/VzSj79" className="hover:text-violet-400">
            <button className="btn-primary">Sign in</button>
          </Link>
        </div>
      </nav>
      <main className="flex-1 relative overflow-y-auto px-8 py-8">
        <div className="h-full w-full text-center mb-24 py-4 sm:py-20">
          <div className="inline-block mb-4 px-4 py-1.5 bg-zinc-800 text-violet-400 text-sm font-medium rounded-sm">
            Launching on Product Hunt Soon
          </div>
          <h1 className="font-black text-white mb-6 leading-tight text-4xl sm:text-6xl sm:max-w-4xl mx-auto">
            The Consumer Intelligence Platform.{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-cyan-400">
              Just Ask
            </span>{" "}
            and feel the Beat of the world
          </h1>
          <p className="text-xl text-zinc-400 sm:max-w-2xl mx-auto mb-10">
            Get consumer insights in minutes, with AI-generated cohorts and
            perfect Demographic matching.
          </p>
          <div className="flex justify-center space-x-4">
            <Link
              to="/workspaces/VzSj79"
              className="px-4 sm:px-8 py-4 bg-violet-600 hover:bg-violet-500 text-white font-medium transition-colors duration-200"
            >
              Start Asking Now
            </Link>
            <button className="px-4 sm:px-8 py-4 bg-zinc-800 hover:bg-zinc-700 text-white font-medium transition-colors duration-200">
              Book a Demo
            </button>
          </div>
          <div className="mt-12 text-zinc-500 text-sm">
            Trusted by teams at
            <div className="flex justify-center items-center space-x-8 mt-6">
              <span className="font-semibold text-zinc-400">
                Goodle Deepmind
              </span>
              <span className="font-semibold text-zinc-400">Sequoia</span>
              <span className="font-semibold text-zinc-400">OpenAI</span>
              <span className="font-semibold text-zinc-400">MIT</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProjectHomePage;
